import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { validateFields, validateField } from '../../../../utilities/validation/validator';
import { getDefaultDate, formatTimeSlots, getFormatDateWithTime } from '../../../../utilities/dateUtils';
import { regexPatterns } from '../../../../utilities/validation/validationVariables';
import ProviderManager from '../../../../provider/providerManager';
import lodash from 'lodash';

export const getTimeSlots = createAsyncThunk('TechnicianArrivalTime/getTimeSlots', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getTimeSlots', [
      data.city,
      data.cityCode,
      data.streetCode,
      data.entrance,
      data.typeName,
      '322',
      data.zipCode,
      data.captchaToken,
      '0',
      '0',
      '48',
      data.distributionType,
      data.infrastructure
    ]);
    return result;
  } catch (error) {
    return error;
  }
});

export const getTimeSlotsFromDate = createAsyncThunk('TechnicianArrivalTime/getTimeSlotsFromDate', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getTimeSlotsFromDate', [
      getFormatDateWithTime(data.fromDate),
      data.city,
      data.cityCode,
      data.streetCode,
      data.entrance,
      data.typeName,
      '322',
      data.zipCode,
      data.addDays,
      data.captchaToken,
      '0',
      '0',
      data.distributionType,
      data.infrastructure
    ]);
    return result;
  } catch (error) {
    return error;
  }
});

const TechnicianArrivalTimeSlice = createSlice({
  name: 'technicianArrivalTime',
  initialState: {
    form: {
      // address data will come from the user login data , when it will be ready to use
      valid: '',
      timeSlots: [],
      arrivalTime: '',
      floor: '',
      arrivalStartDate: '',
      arrivalEndDate: '',
      isLoading: true,
      errorId: 0,
      errorObj: '',
      errors: {},
      rules: {
        arrivalTime: {
          required: { value: true, error: 'לא נבחר מועד' },
        }
      },
    },
  },

  reducers: {
    validateHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const validate = validateFields(lodash.cloneDeep(payload));
        return { payload: validate };
      },
    },
    clearValid: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    initValidation: {
      reducer(state, action) {
        state.form.valid = '';
      },
    },
    startLoading: {
      reducer(state, action) {
        const form = { ...state.form };
        form.isLoading = false;
        state['form'] = form;
      },
    },
    changeHandler: {
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        form.arrivalStartDate = payload.target.startDate;
        form.arrivalEndDate = payload.target.endDate;

        const maxLength = payload.target.maxLength;
        const message = value.slice(0, maxLength);

        const validate = validateField(form, name, message);

        return { payload: validate };
      },
    },
    setFloorValidation: {
      reducer(state, action) {
        state.form.rules['floor'] = { required: { value: true, error: 'יש להזין מספר קומה' } }
      },
    },
  },
  extraReducers: {
    [getTimeSlots.fulfilled]: (state, action) => {
      let body = action.payload.Body;
      let header = action.payload.Header;

      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 53, message: action.payload.message };
        state.form.errorId = 53;
        return;
      }

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = { errorId: 18, message: action.payload.message };
        state.form.errorId = 18;
        return;
      }

      if (header != undefined) {
        if (header.ReturnCode != 0) {
          state.form.errorObj = { errorId: 53, message: header.ReturnCodeMessage };
          state.form.errorId = 53;
          return;
        }
      }

      try {
        state.form.timeSlots = formatTimeSlots(body);
        state.form.isLoading = false;
      } catch (error) {
        state.form.errorObj = { errorId: 53, message: 'cannot format time slots' };
        state.form.errorId = 53;
      }
    },
    [getTimeSlotsFromDate.fulfilled]: (state, action) => {
      let body = action.payload.Body;
      let header = action.payload.Header;

      if (action.payload.errorCode != undefined && action.payload.errorCode == 1200) {
        state.form.errorObj = { errorId: 18, message: action.payload.message };
        state.form.errorId = 18;
        return;
      }

      if (action.payload.message !== '' && action.payload.message != undefined) {
        state.form.errorObj = { errorId: 0, message: action.payload.message };
        state.form.errorId = 0;
        return;
      }

      if (header != undefined) {
        if (header.ReturnCode != 0) {
          state.form.errorObj = { errorId: 53, message: header.ReturnCodeMessage };
          state.form.errorId = 53;
          return;
        }
      }

      try {
        state.form.timeSlots = formatTimeSlots(body);
        state.form.isLoading = false;
      } catch (error) {
        state.form.errorObj = { errorId: 53, message: 'cannot format time slots' };
        state.form.errorId = 53;
      }
    },
  },
});

export const { changeHandler, validateHandler, startLoading, initValidation, clearValid, setFloorValidation } = TechnicianArrivalTimeSlice.actions;
export default TechnicianArrivalTimeSlice.reducer;
